import { RouteConfig, Route, NavigationGuardNext } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { DASHBOARD_AUTH_ROUTES } from '@/views/DashboardAuth/utils'
import { DASHBOARD_LK_ROUTES } from '@/views/DashboardLK/utils'
import { HOME_LK_ROUTES } from '@/views/HomeLK/utils'
import { ERRORS_ROUTES } from '@/views/Errors/utils'
import { HOME_ROUTES } from './utils'

type Options = Required<CreateRouterOptions>

const createRoutes = ({ router }: Options): RouteConfig[] => [
  {
    path: '/',
    name: HOME_ROUTES.INDEX,
    beforeEnter(to: Route, from: Route, next: NavigationGuardNext) {
      const { resolved: currentResolved } = router.resolve({ path: from.path })
      let { path: currentPath } = currentResolved.matched[0]

      if (!currentPath) {
        next({ name: HOME_LK_ROUTES.LAYOUT })
        return
      }

      if (currentPath === '*') {
        currentPath = window.location.pathname
      }

      const isResolved = [
        DASHBOARD_AUTH_ROUTES.INDEX,
        DASHBOARD_LK_ROUTES.INDEX,
        HOME_LK_ROUTES.LAYOUT,
      ].some((name) => {
        try {
          const { resolved } = router.resolve({ name })
          const { path } = resolved.matched[0] || {}
          if (currentPath.includes(path)) {
            next({ name })
            return true
          }
        } catch {
          //
        }

        return false
      })

      if (isResolved) return

      if (from.name === HOME_ROUTES.INDEX) {
        next({ name: ERRORS_ROUTES.ERROR_404 })
      } else {
        next({ name: HOME_LK_ROUTES.LAYOUT })
      }
    },
  },
]

const createModule = (options: Options): RouteConfig[] => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
